import React from 'react';
import noop from 'lodash/noop';
import classNames from 'classnames';
import Button from '../button';
import { Size } from '../_util/enum';
const SortButton = props => {
    const { moveToUp = noop, moveToDown = noop, upArrowText = '', downArrowText = '', upActive, downActive, className, } = props;
    const customUpClass = classNames(`${className}-custom-up-active`, {
        [`${className}-custom-up-disable`]: !upActive,
    });
    const customDownClass = classNames(`${className}-custom-down-active`, {
        [`${className}-custom-down-disable`]: !downActive,
    });
    return (React.createElement("div", { className: className },
        typeof upArrowText === 'string' ? (React.createElement(Button, { type: "primary", size: Size.small, disabled: !upActive, onClick: moveToUp, icon: "keyboard_arrow_up" }, upArrowText)) : (React.createElement("div", { className: customUpClass, onClick: upActive ? moveToUp : undefined }, upArrowText)),
        typeof downArrowText === 'string' ? (React.createElement(Button, { type: "primary", size: Size.small, disabled: !downActive, onClick: moveToDown, icon: "keyboard_arrow_down" }, downArrowText)) : (React.createElement("div", { className: customDownClass, onClick: downActive ? moveToDown : undefined }, downArrowText))));
};
export default SortButton;
